const SingleDot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6}
    height={6}
    fill="none"
    {...props}
  >
    <circle cx={3} cy={3} r={3} fill="currentColor" />
  </svg>
);
export default SingleDot;
